export default __webpack_public_path__ + "static/media/hamburger_logo_expand.a715d57d.png";